// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"ae0f74e8","49":"9808506e","64":"c4110399","96":"1183dceb","199":"2f8304b3","273":"4dbcb176","624":"c331b17f","694":"a6cf36e9","703":"1d5b572d","717":"548f5a4f","787":"3866bf13","996":"fdc92f5e"}[chunkId] + ".chunk.js";
};